'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeNode = undefined;

var _Tree = require('./Tree');

var _Tree2 = _interopRequireDefault(_Tree);

var _TreeNode = require('./TreeNode');

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Tree2['default'].TreeNode = _TreeNode2['default'];

exports['default'] = _Tree2['default'];
exports.TreeNode = _TreeNode2['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_rc-tree@1.7.1@rc-tree/lib/index.js
// module id = 274
// module chunks = 0 1